import React from 'react';
import { useWindowSize } from 'react-use';

function Container({children}) {

  return  <div style={{minHeight: '100vh'}}>
    {children}
  </div>
}

export default Container;